export default function Header() {
  return (
    <header id="header">
      <h1>CV Generator</h1>
    </header>
  );
}
